import $ from 'jquery';

class Accessibility{
    run(){
        document.getElementById('highcontrast').addEventListener('click', () => {
            this.cookie();
            document.querySelector('html').classList.toggle('high-contrast');
        });
    }

    cookie(){
        var mode = getCookie("mode");

        if(mode == 'default'){
            setCookie("mode","high-contrast");
        } else {
            setCookie("mode","default");
        }

        function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        function setCookie(cname, cvalue) {
            var d = new Date();
            d.setTime(d.getTime() + (10*365*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
    }
}
const accessibility = new Accessibility();
export default accessibility;
